<template>
  <div :class='["wrapper", headerCheckbox ? "from-header" : "", offset ? "offset" : ""]'
    @click='click'
    @mouseenter='hover'
    @mouseleave='blur'
    v-tooltip.bottom='tooltip'
  >
  </div>
</template>

<script>

export default {
  props: ['context', 'headerCheckbox'],
  computed: {
    tooltip() {
      return this.headerCheckbox
        ? 'Click to select all rows'
        : 'Select this row for more actions'
    },
    offset() {
      return (this.context || {}).dragRows
    }
  },
  methods: {
    click() {
      const checkbox = elCheckbox.call(this)
      checkbox.click()
    },
    hover() {
      const checkbox = elCheckbox.call(this)
      checkbox.className += ' hover'
    },
    blur() {
      const checkbox = elCheckbox.call(this)
      checkbox.className = checkbox.className.replace(' hover', '')
    }
  }
}

function elCheckbox() {
  const checkbox = this.headerCheckbox
    ? '[class^="ag-checkbox-"]:not(.ag-hidden) .ag-icon'
    : '.ag-selection-checkbox .ag-icon:not(.ag-hidden)'
  return (this.headerCheckbox || this.params.eGridCell).querySelector(`${checkbox}`)
}

</script>

<style lang='scss' scoped>

.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 74%;

  &.from-header {
    cursor: pointer;
  }
  &.offset {
    margin-left: 21px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/cells/checkboxProxy.vue